import Card from "@mui/material/Card";
import SoftUITabs from "./SoftUITabs/SoftUITabs";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SoftButton from "components/SoftButton";
import env from "config";
import { useAgencyInfo } from "context/agency";
import { useEffect, useState } from "react";
import General from "./BrandingTabs/General";
import "./style.css";
import { CircularProgress, Snackbar, useMediaQuery, useTheme } from "@mui/material";
import Domain from "./BrandingTabs/Domain";
import { useAppServices } from "hook/services";
import imageDemo from "assets/images/image.jpg";
import Content from "./BrandingTabs/Content";
import OtherPage from "./BrandingTabs/OtherPages";
import CategoryManager from "./BrandingTabs/Category";
import SubCategoryManager from "./BrandingTabs/SubCategory";
import CustomTabs from "layouts/super-admin/components/CustomTabs";
import Menu from "./BrandingTabs/Menu";
import toast from "react-hot-toast";
import Loader from "examples/Loader";
import { useLocation } from "react-router-dom";
import { useKnowledgeBase } from "context/knowledgebaseContext";
import PageTitle from "../../../../components/PageTitle";
import PageLayout from "examples/LayoutContainers/PageLayout";
import "../../../settingsCompact.css";
import { DEFAULT_HOME_SECTION_ORDER } from "constants/homeSectionOrder";

function BasicInfo({ handleImage, loading }) {
  const Service = useAppServices();
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const customUrlDomain = env.ACCOUNT_LEVEL_URL;
  const [errorMsg, setErrorMsg] = useState("");
  const [successMsg, setSuccessMsg] = useState("");
  const [gateway, setGatway] = useState("");
  const [agency, , , , , , Update] = useAgencyInfo();
  const [copy, setcopy] = useState(false);
  const [selectedTheme, setSelectedTheme] = useState([]);
  const [themes, setThemes] = useState([]);
  const [loader, setLoader] = useState(false);
  const [open, setOpen] = useState(false);
  const [themeStatus, setThemeStatus] = useState("inactive");
  const [categories, setCategories] = useState([]);
  const [buttonLoading, setButtonLoading] = useState(false);
  const location = useLocation();
  const { knowledgeBase } = useKnowledgeBase();
  const [domainMessageDisconnect, setDomainMessageDisconnect] = useState("");

  const searchParams = new URLSearchParams(location.search);
  const hasDomainQuery = searchParams.has("domain");
  const hasMenuQuery = searchParams.has("menu");

  const [activeTab, setActiveTab] = useState(0);

  const url = agency?.domain
    ? `https://${agency.domain}/{{user.email}}/{{location.id}}/app/home?sessionKey={{user.sessionKey}}`
    : `${customUrlDomain}/{{user.email}}/{{location.id}}/app/home?sessionKey={{user.sessionKey}}`;
  const handlecopy = () => {
    setcopy(true);

    setTimeout(() => {
      setcopy(false);
    }, 2000);
  };

  useEffect(() => {
    if (hasDomainQuery) {
      setActiveTab(1);
    } else if (hasMenuQuery) {
      setActiveTab(3);
    } else {
      setActiveTab(0);
    }
  }, [location.search]);

  /** Home page section toggles: on unless explicitly saved as false in theme_data.content */
  const defaultHomeSectionContent = {
    showBusinessesByTagOnHome: true,
    showBlogsOnHome: true,
    showFeaturedListingOnHome: true,
    showHeroSection: true,
    showSiteDescription: true,
    showFeaturedListingsSlider: true,
    showFreeListings: true,
    showEvents: true,
    showJobs: true,
    showNews: true,
    showHomepageOptinOnHome: true,
  };

  const handelThemeData = async (data, setResponseMessage, setOpen) => {
    const reportMessage = (msg) => {
      if (typeof setResponseMessage === "function") setResponseMessage(msg);
    };
    const openSnackbar = () => {
      if (typeof setOpen === "function") setOpen(true);
    };

    setButtonLoading(true);
    try {
      const submitData = {
        ...selectedTheme,
      };

      if (submitData.theme_data && submitData.theme_data.domain) {
        submitData.theme_data.domain.domain_update = false;
      }
      // Deep merge general and content objects to preserve existing data
      const updatedThemeData = {
        ...submitData.theme_data,
        // Deep merge general object
        general: {
          ...submitData.theme_data?.general,
          ...data?.general,
        },
        // Deep merge content object (defaults first so legacy themes without these keys get all sections on)
        content: {
          ...defaultHomeSectionContent,
          ...(submitData.theme_data?.content || {}),
          ...(data?.content || {}),
        },
        // Preserve other properties from data (like domain, menu_customize, pages, etc.)
        ...Object.keys(data || {}).reduce((acc, key) => {
          if (key !== "general" && key !== "content") {
            acc[key] = data[key];
          }
          return acc;
        }, {}),
      };
      if (updatedThemeData?.general?.logo && !updatedThemeData?.general?.logo.includes("https")) {
        toast.error("Error while uploading Logo");
        return { success: false, message: "Error while uploading Logo" };
      }

      if (
        updatedThemeData?.general?.Meta_logo &&
        !updatedThemeData?.general?.Meta_logo.includes("https")
      ) {
        toast.error("Error while uploading Meta Logo");
        return { success: false, message: "Error while uploading Meta Logo" };
      }

      if (
        updatedThemeData?.general?.footer_logo &&
        !updatedThemeData?.general?.footer_logo.includes("https")
      ) {
        toast.error("Error while uploading Footer Logo");
        return { success: false, message: "Error while uploading Footer Logo" };
      }

      if (
        updatedThemeData?.general?.auth_logo &&
        !updatedThemeData?.general?.auth_logo.includes("https")
      ) {
        toast.error("Error while uploading Auth Logo");
        return { success: false, message: "Error while uploading Auth Logo" };
      }

      const payload = {
        agency_id: agency?._id,
        theme_data: updatedThemeData,
        theme_type: "agency",
        theme_id: selectedTheme.theme_id,
      };
      const { response, error } = await Service.themes.updateOrCreateByAgencyId({ payload });
      if (response?.success) {
        setSelectedTheme((prev) => ({
          ...prev,
          theme_data: updatedThemeData,
        }));
        reportMessage("Theme Updated Successfully");
        openSnackbar();
        setSuccessMsg(true);
        setErrorMsg(false);
        return { success: true, message: "Theme Updated Successfully" };
      }
      setSuccessMsg(false);
      const failureMsg = error?.message || "Failed to update theme";
      reportMessage(failureMsg);
      setErrorMsg(error?.message || false);
      return { success: false, message: failureMsg };
    } catch (error) {
      setErrorMsg(true);
      if (error?.response?.status === 504) {
        setGatway(true);
        reportMessage("Theme Updated Successfully");
        return { success: true, message: "Theme Updated Successfully" };
      }
      if (error?.message?.includes("Network Error") || error?.code === "ECONNABORTED") {
        setGatway(true);
        reportMessage("Theme Updated Successfully");
        return { success: true, message: "Theme Updated Successfully" };
      }
      return { success: false, message: error?.message || "Failed to update theme" };
    } finally {
      setButtonLoading(false);
    }
  };
  const getCategories = async () => {
    try {
      const { response } = await Service.topnav_categories.get({
        query: `agency_id=${agency._id}`,
      });
      setCategories(response?.data || []);
    } catch (error) {
      console.error("Error fetching categories:", error);
    }
  };

  useEffect(() => {
    getCategories();
  }, []);

  const selectTheme = async (theme) => {
    setLoader(true);
    const { response } = await Service.themes.get({
      query: `theme_type=agency&agency_id=${agency?._id}`,
    });
    if (response?.data.length == 0) {
      await Service.themes
        .updateOrCreateByAgencyId({
          payload: {
            agency_id: agency?._id,
            theme_data: {
              ...theme.theme_data,
              content: {
                ...defaultHomeSectionContent,
                homeSectionOrder: DEFAULT_HOME_SECTION_ORDER,
                ...(theme.theme_data?.content || {}),
              },
            },
            theme_type: "agency",
            theme_id: theme._id,
          },
        })
        .then((response) => {
          setSelectedTheme(response?.response?.data);
          setLoader(false);
        });
    } else {
      setSelectedTheme(response?.data[0]);
      setLoader(false);
    }
  };

  useEffect(() => {
    selectTheme();
  }, []);

  useEffect(() => {
  if (!domainMessageDisconnect) return;

  const timer = setTimeout(() => {
    setDomainMessageDisconnect("");
  }, 3000);

  return () => clearTimeout(timer);
}, [domainMessageDisconnect]);

  const tabsData = [
    {
      label: "General",
      key: "general",
      content: (
        <General
          selectedTheme={selectedTheme}
          handelThemeData={handelThemeData}
          handleImage={handleImage}
          loading={loading}
          buttonLoading={buttonLoading}
        />
      ),
    },
    {
      label: "Domain",
      content: (
        <Domain
          selectedTheme={selectedTheme}
          handleImage={handleImage}
          handelThemeData={handelThemeData}
          open={open}
          setOpen={setOpen}
          loading={loading}
          buttonLoading={buttonLoading}
          errorMsg={errorMsg}
          successMsg={successMsg}
          gateway={gateway}
          handleRefresh={selectTheme}
          domainMessageDisconnect={domainMessageDisconnect}
          setDomainMessageDisconnect={setDomainMessageDisconnect}
        />
      ),
    },
    // {
    //   label: "Pages",
    //   content: (
    //     <OtherPage
    //       selectedTheme={selectedTheme}
    //       handleImage={handleImage}
    //       handelThemeData={handelThemeData}
    //       buttonLoading={buttonLoading}
    //       loading={loading}
    //     />
    //   ),
    // },
    {
      label: "Content",
      content: (
        <Content
          selectedTheme={selectedTheme}
          handleImage={handleImage}
          handelThemeData={handelThemeData}
          buttonLoading={buttonLoading}
          loading={loading}
        />
      ),
    },

    // {
    //   label: "Category",
    //   content: (
    //     <CategoryManager
    //       selectedTheme={selectedTheme}
    //       handleImage={handleImage}
    //       handelThemeData={handelThemeData}
    //       loading={loading}
    //       categories={categories}
    //       buttonLoading={buttonLoading}
    //       handleRefresh={getCategories}
    //     />
    //   ),
    // },

    // {
    //   label: "SubCategory",
    //   content: (
    //     <SubCategoryManager
    //       selectedTheme={selectedTheme}
    //       handleImage={handleImage}
    //       handelThemeData={handelThemeData}
    //       loading={loading}
    //       categories={categories}
    //       buttonLoading={buttonLoading}
    //       handleRefresh={getCategories}
    //     />
    //   ),
    // },
    {
      label: "Menu Builder",
      content: (
        <Menu
          selectedTheme={selectedTheme}
          handleImage={handleImage}
          handelThemeData={handelThemeData}
          loading={loading}
          categories={categories}
          buttonLoading={buttonLoading}
          handleRefresh={getCategories}
        />
      ),
    },
  ];

  const getThemes = async (queryTheme) => {
    const { response } = await Service.themes.get({ query: queryTheme });
    if (response) {
      setThemes(response.data);
    } else {
      setThemes([]);
    }
  };

  useEffect(() => {
    getThemes("theme_type=supperadmin");
  }, []);

  const activeTheme = async () => {
    const payload = {
      _id: agency?._id,
      theme_id: selectedTheme._id,
    };
    const { response } = await Service.agency.update({ payload });
    if (response) {
      const payload = {
        agency_id: agency?._id,
        _id: selectedTheme._id,
        status: "active",
      };

      const { response } = await Service.themes.ActiveOrDeActive({ payload });
      if (response) {
        setOpen(true);
        setSelectedTheme("active");
      }
    }
  };

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };
  return (
    <>
      {loader ? (
        <Loader />
      ) : (
        <>
          <style>
            {`
                 .kb-help-text-btn {
            display: inline-flex;
            align-items: center;
            gap: 8px;
            padding: 6px 12px;
            border-radius: 8px;
            background: #f9fafb;
            border: 1px solid #e5e7eb;
            font-size: 13px;
            font-weight: 500;
            color: #374151;
            cursor: pointer;
            transition: all 0.2s ease;
          }
          
          .kb-help-text-btn:hover {
            background: #eef2ff;
            color: #2f80ed;
            border-color: #c7d2fe;
          }
          
          `}
          </style>
          <PageLayout>
            <SoftBox alignItems="center" className="sd-settings sd-settings-branding sd-page">
              <div className="sd-settings__header sd-page__header d-flex w-100 align-items-center">
                <PageTitle helpUrl={knowledgeBase?.branding}>Branding</PageTitle>
              </div>
              <CustomTabs tabsData={tabsData} activeTab={activeTab} setActiveTab={setActiveTab} />
            </SoftBox>
          </PageLayout>
        </>
      )}
    </>
  );
}
export default BasicInfo;